import React from "react";
import { Form, Col, Container, Row } from "react-bootstrap";
import PostcodeInput from "../Common/PostcodeInput";

const statusOptions = [
  { value: "", label: "-- Wszystkie --" },
  { value: "-2", label: "Odrzucony przez Algolytics" },
  { value: "-1", label: "Odrzucony przez DHL" },
  { value: "1", label: "W trakcie analizy" },
  { value: "2", label: "Zgłoszony przez DHL" },
  { value: "3", label: "Zaakceptowany przez Algolytics" },
];

const NewAddressFilters = ({ onFilterChange, onSearch, onImmediateFilterChange, filters = {} }) => {
  return (
    <Container className="mt-4">
      <Form onKeyDown={(e) => { if (e.key === 'Enter' && !['TEXTAREA', 'SELECT'].includes(e.target.tagName)) { e.preventDefault(); onSearch?.(); } }}>
        <Row className="mb-3">
          <Col md={3}>
            <Form.Group controlId="cityName">
              <Form.Label>Miejscowość</Form.Label>
              <Form.Control
                type="text"
                placeholder="Miejscowość..."
                value={filters.cityName || ""}
                onChange={(e) => onFilterChange("cityName", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="postcode">
              <Form.Label>Kod pocztowy</Form.Label>
              <PostcodeInput
                value={filters.postcode || ""}
                onChange={(val) => onFilterChange("postcode", val)}
                 inputMode="numeric"
              />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group controlId="street">
              <Form.Label>Ulica</Form.Label>
              <Form.Control
                type="text"
                placeholder="Ulica..."
                value={filters.street || ""}
                onChange={(e) => onFilterChange("street", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group controlId="status">
              <Form.Label>Status</Form.Label>
              <Form.Select
                value={filters.status ?? ""}
                onChange={(e) => (onImmediateFilterChange || onFilterChange)("status", e.target.value)}
              >
                {statusOptions.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>
      </Form>
    </Container>
  );
};

export default NewAddressFilters;
